import { IAppState } from "..";

export const getSelectedUser = (state: IAppState) => state.users.selectedUser;

export const getIsLoadingUsers = (state: IAppState) => state.users.isLoadingUsers;
